import { Button, Form, Input, InputNumber, Select, Space } from 'antd';
import { useEffect, useState } from 'react';
import getList from '../universal/getList';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import fetchApi from '../../utils/api/fetchApi';
import systemConfig from '../../config/systematic';

//  主配料formList通用组件
export default function WebRequireMentFormList(props: any) {

    const { formName, expandCategoryName, expandCategoryId } = props;
    const { form } = props.props;

    /**需求内容数据 */
    const [expandTypeData, setExpandTypeData] = useState<any>();

    /**产品单位数据 */
    const [productUnitData, setProductUnitData] = useState<any>();

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    useEffect(() => {
        const fetchData = async () => {

            fetchApi.GET(wmService, {
                apiId: "productUnit",
                apiExtend: 'showList'
            }).then(res => {
                setProductUnitData(res.data);
            });

        }
        fetchData()
    }, [])

    const customizeAdd = (add: Function, expandCategoryId: any) => {
        add();
        form.setFieldValue([formName, form.getFieldsValue()[formName].length - 1], { expandCategoryId, state: "insert" });
    }

    //remove 删除
    const removeList = (remove: Function, num: number, key: number) => {

        remove(num);

        if (expandTypeData) {
            delete expandTypeData[key];
        }
    }

    return (
        <>
            <Form.List name={formName}>
                {(fields, { add, remove }) => {
                    return (
                        <>
                            {fields.map(({ key, name, ...restField }) => (
                                <Space
                                    key={key}
                                    style={{ display: 'flex', marginBottom: 8 }}
                                    align="baseline"
                                >
                                    <Form.Item
                                        {...restField}
                                        // label="原材料"
                                        name={[name, 'expandTypeId']}
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入' + expandCategoryName,
                                            },
                                        ]}
                                    >
                                        <Select
                                            //optionLabelProp="label"
                                            style={{ width: 220 }}
                                            showSearch
                                            allowClear
                                            onSearch={(e) => getList.searchEx('expandType', setExpandTypeData, e, expandTypeData, {
                                                apiExtend: 'showListForRequireMent',
                                                keyId: key,
                                                isFormList: true,
                                                form,
                                                FormListName: formName,
                                                name,
                                                andWhereObj: {
                                                    expandCategoryId,
                                                    mountDataOptions: {
                                                        userMount: {
                                                            isDept: true
                                                        }
                                                    },
                                                }
                                            })}
                                            placeholder={expandCategoryName}
                                            optionFilterProp="children"
                                            filterOption={(input, option: any) => {
                                                return true
                                            }}
                                        >
                                            {getList.general(expandTypeData ? expandTypeData[key] ? expandTypeData[key] : [] : [], "expandTypeName")}
                                        </Select>
                                    </Form.Item>

                                    <Form.Item
                                        // label="定量"
                                        {...restField}
                                        name={[name, 'amount']}
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入定量',
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            style={{ width: 80 }}
                                            placeholder="定量"
                                            min={0.01}
                                            step={0.01}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        {...restField}
                                        // label="单位"
                                        name={[name, 'productUnitId']}
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入单位',
                                            },
                                        ]}
                                    >
                                        <Select
                                            style={{ width: 90 }}
                                            showSearch
                                            placeholder="单位"
                                            optionFilterProp="children"
                                            filterOption={(input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                            {getList.generalEx(productUnitData, {
                                                itemName: "productUnitName",
                                                includeNull: false,
                                            })}
                                        </Select>
                                    </Form.Item>

                                    <Form.Item
                                        // label="备注"
                                        {...restField}
                                        name={[name, 'memo']}
                                    >
                                        <Input
                                            style={{ width: 220 }}
                                            placeholder="备注"
                                        />
                                    </Form.Item>

                                    <MinusCircleOutlined onClick={() => removeList(remove, name, key)} />
                                </Space>
                            ))}
                            <Form.Item>
                                <Button
                                    type="dashed"
                                    onClick={() => customizeAdd(add, expandCategoryId)}
                                    block
                                    icon={<PlusOutlined />}
                                >
                                    添加
                                </Button>
                            </Form.Item>
                        </>
                    )
                }
                }
            </Form.List>
        </>
    )
}